export const REQUIRED_ERROR_TEXT = 'This field is required!';
export const MAX_LENGTH_ERROR_TEXT = (maxLength: number): string =>
  `Maximum length for this field is: ${maxLength} words!`;
export const MIN_LENGTH_ERROR_TEXT = (minLength: number): string =>
  `Minimum length for this field is: ${minLength} words!`;
export const MAX_VALUE_ERROR_TEXT = (max: number): string =>
  `Maximum value for this field is: ${max}!`;
export const MIN_VALUE_ERROR_TEXT = (min: number): string =>
  `Minimum value for this field is: ${min}!`;
export const PATTERN_VALUE_ERROR_TEXT = (pattern: RegExp): string =>
  `Value should match the pattern: ${pattern}!`;
